<template>
  <div class="animated fadeIn list-of-opi">
    <b-card>
      <div slot="header">Booking Space Iklan Cetak
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
          <button class="btn btn-primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</button>
            <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="6">
              <b-row>
                <b-col md="12" xl="10">
                  <b-input-group >
                    <!-- <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl. OPI</span></b-input-group-prepend> -->
                      <b-input-group-prepend><label >Jadwal Tayang</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>  
              <b-row>
                <b-col md="12" xl="10">
                  <b-input-group >
                    <b-input-group-prepend><label>Halaman/Rubrik</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.posisirubrik" ></b-form-input>
                    <b-form-radio-group  v-model="tblData.classad" name="clasAdvertising" class="ml-1 mt-1">
                        <b-form-radio :value="0">Display/Umum</b-form-radio>
                        <b-form-radio :value="1">Kolom/Class Ad.</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
                </b-col>
              </b-row>  
        </b-col>
        <b-col md="6" xl=5>
              <b-input-group>
                <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                <b-form-input v-model="tblData.jiklan" @change="tblData.jiklanid=''" ></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuJenisIklanShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append class="ml-2">
                  <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
                </b-input-group-append>
              </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jiklan)="data">
          {{data.item.jiklan}} <span v-if="data.item.baris==0"> ({{data.item.jwarna}}) </span>
        </template>
        <template v-slot:cell(jadwalmuat)="data">
          {{ data.item.jadwalmuat | moment("DD MMM YYYY") }}
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
         <b-modal v-model="lkuJenisIklanShow" size="lg" :hide-footer="true" title="Jenis Iklan" :centered="true" :lazy="true">
            <lku-jenisiklan @click="onSelectLkuJenisIklan" ></lku-jenisiklan>
        </b-modal>  

  </div>
</template>

<style lang="scss">
  .list-of-opi {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import opi from "../../apis/koran_iklanmuat";
import lkuJenisiklan from "../lookup/lkuJenisIklanAll";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading,lkuJenisiklan},
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            closevoidnote: { required },
        },
        frmdata: {
            halaman: { required },
        },
  }, 
  data() {
    return {
      lkuJenisIklanShow: false,
      lkuCustomerShow: false,
      showFilter: false,
      showDelConfirm: false,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",
        postgroup:"",
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
    tblFields:[
          {
            key: "jadwalmuat",
            label: "Jadwal",
            thStyle: "width:100px",
            sortable: true,
          },
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "CustName",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
            sortable: true
          },
          {
            key: "ukuraniklan",
            label: "Ukuran",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "posisirubrik",
            label: "Halaman/Rubrik",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      ],
    };
  },
  computed: {
    invalidFormdata (){
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },    
  },
  created: async function(){
        const tgl1 = moment().format('YYYY-MM-DD');
        const tgl2 = moment().format('YYYY-MM-DD');
        this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        this.tblData.tgl2=this.tblData.tgl2 || tgl2;
  },  
  methods: {
    onSelectLkuJenisIklan: async function (_selected) {
      this.tblData.jiklanid = _selected.jiklanid;
      this.tblData.jiklan = _selected.jenisiklan;
      this.lkuJenisIklanShow=false;
    },    

    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.bookspacecetak) {
            this.tblData[key] = filter.bookspacecetak[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.bookspacecetak.tgl1 || '';
          this.tblData.tgl2=filter.bookspacecetak.tgl2 || '';
          this.showFilter=filtered;
          delete filter.bookspacecetak;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await opi.bookingspace(this.tblData);   
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.juduliklan=  '';
        this.tblData.orderno=  '';
        this.tblData.platform=  '';
        this.tblData.customer_id=  '';
        this.tblData.pemasang=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';

        this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'sales_search', 'baris','jiklan', 'jiklanid', 'posisirubrik','completed'];
      let filtered = false;
      const bookspacecetak={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              bookspacecetak[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          bookspacecetak.page=this.tblData.page;
          bookspacecetak.limit=this.tblData.limit;
          bookspacecetak.sortBy=this.tblData.sortBy;
          bookspacecetak.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.bookspacecetak=bookspacecetak;
          this.$store.commit("filter", filter);
      }
    },    
    rowClicked(record, index) {
        if ((this.frmdata) && (this.frmdata._rowVariant)) {
            delete this.frmdata._rowVariant;
        }
        this.frmdata = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await opi.exportbookspace(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    print: async function()
    {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
          try {
              this.isLoading=true;
                this.showReport=true;
              this.reportUrl = await opi.printbookspace(this.tblData);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
              // console.log(error);
          }
        }
    },

    close(){
        // router.push({name:'opiment.home'});
          router.push({name: "iklankoran.home"});
    }

  }
};
</script>
